import {
  ProductListItemsPatchDto,
  ProductReferenceWithExtraOptions,
} from '@epicuro-next/data/engagement/engagement-models';

export function extractPatchItemsPayload({
  itemsToAdd,
  itemsToDelete,
}: ProductListItemsPatchDto) {
  return {
    itemsToAdd: mapProductsReference(itemsToAdd),
    itemsToDelete: mapProductsReference(itemsToDelete),
  };
}

function mapProductsReference(
  productReferences: ProductReferenceWithExtraOptions[],
) {
  return productReferences.map(({ productId, brandId, deliveryInfo }) => ({
    productId,
    brandId,
    deliveryInfo,
  }));
}
